import { gql } from 'apollo-angular';
import { ResourceAssignment } from '../../../../shared/entities/resourceAssignment/resourceAssignment';

export const RENTAL_RESOURCE_ASSIGNMENT_REVIEW_QUERY = gql`
query getResourceAssignments(
  $ids: [UUID]
)
{
  resourceAssignments: getResourceAssignments(
    ids: $ids
  ){
    text
    protocols {
        id
        type
        state
        completedDateTime
        completedBy {
            firstName
            lastName
        }
        formControlTemplate
        task{
        id
        assignment {
            assigneeId
            assignmentType
            typeLabel
            name
            }
        }
    }
    resource {
        id
        text
    }
    lineItem {
        article{
            name
        }
    }
  }
}

`;

export interface RentalResourceAssignmentReviewQuery {
  resourceAssignments: ResourceAssignment[];
}
